import Add16 from '@carbon/icons-react/es/add/16';
import Save16 from '@carbon/icons-react/es/save/16';
import React, { FC } from 'react';
import { FormattedMessage } from 'react-intl';
import styled from 'styled-components';
import { User } from 'api/models';
import { Button } from 'components/atoms/button';
import { InviteMemberFormPayload } from 'components/organisms/module-settings/team-members/invite-modal/form-v2';

const StyledDiv = styled.div`
  display: flex;
  align-items: center;
  justify-content: flex-end;

  button {
    margin-left: var(--spacing-05);
  }
`;

export const TeamMemberDrawerFooter: FC<{
  user?: User;
  isSaving: boolean;
  onInvite(): void;
  onUpdate(payload: InviteMemberFormPayload | User): void;
  onClose(): void;
}> = ({ user, isSaving, onInvite, onUpdate, onClose }) => (
  <StyledDiv>
    <Button onClick={onClose}>
      <FormattedMessage id="cancel" />
    </Button>
    {user ? (
      <Button
        disabled={false}
        icon={<Save16 />}
        iconPlacement="right"
        loading={isSaving}
        type="primary"
        onClick={() => onUpdate(user)}
      >
        <FormattedMessage id="update" />
      </Button>
    ) : (
      <Button
        disabled={false}
        icon={<Add16 />}
        iconPlacement="right"
        loading={isSaving}
        type="primary"
        onClick={onInvite}
      >
        <FormattedMessage id="invite" />
      </Button>
    )}
  </StyledDiv>
);
